export default __webpack_public_path__ + "static/media/login-bg-26.c8123d4b.jpg";